import { useRegisterSW } from 'virtual:pwa-register/react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';

/** S1-T10: "New version available — Reload". */
export function UpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });
  if (!needRefresh) return null;
  return (
    <div className="fixed inset-x-3 top-3 z-50 mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-stone-900 p-3 text-white shadow-xl">
      <span className="flex-1">{t('app.updateAvailable')}</span>
      <Button size="sm" variant="secondary" onClick={() => setNeedRefresh(false)}>
        {t('common.later')}
      </Button>
      <Button size="sm" onClick={() => void updateServiceWorker(true)}>
        {t('app.reload')}
      </Button>
    </div>
  );
}
